import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './TravelListToolbar.css';

const VIEW_MODES = ['grid', 'short'];

function TravelListToolbar({ count, sortBy, viewMode, onSort, onViewMode }) {
  const { t } = useTranslation();
  const sortLabel = sortBy === 'price'
    ? t('filters.price')
    : t('filters.departDate');

  return (
    <div className="travel-list-toolbar">
      <h2 className="travel-list-toolbar__title">
        {t('results.dealsCount', { count })}
      </h2>
      <div className="travel-list-toolbar__actions">
        <DropdownButton
          id="travel-list-sort"
          title={t('results.sortBy', { option: sortLabel })}
          variant="outline-secondary"
          className="travel-list-toolbar__sort"
        >
          <Dropdown.Item
            active={sortBy === 'date'}
            onClick={() => onSort('date')}
          >
            {t('filters.departDate')}
          </Dropdown.Item>
          <Dropdown.Item
            active={sortBy === 'price'}
            onClick={() => onSort('price')}
          >
            {t('filters.price')}
          </Dropdown.Item>
        </DropdownButton>
        <div
          className="travel-list-view-toggle"
          role="group"
          aria-label={t('results.viewMode')}
        >
          {VIEW_MODES.map((mode) => (
            <button
              key={mode}
              type="button"
              className={
                'travel-list-view-toggle__btn' +
                (viewMode === mode ? ' travel-list-view-toggle__btn--active' : '')
              }
              aria-pressed={viewMode === mode}
              onClick={() => onViewMode(mode)}
            >
              {t(`results.view.${mode}`)}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

TravelListToolbar.propTypes = {
  count: PropTypes.number.isRequired,
  sortBy: PropTypes.string.isRequired,
  viewMode: PropTypes.oneOf(VIEW_MODES).isRequired,
  onSort: PropTypes.func.isRequired,
  onViewMode: PropTypes.func.isRequired,
};

export default TravelListToolbar;
